/** @format */

import React from "react";
import AccountsOverviewContainer from "./AccountsOverview.container";
import "./AccountsOverview.css";

interface IRegistrationFormProps {
	sitekey: string;
	onSuccess: () => void;
}

const AccountsOverview: React.FC<IRegistrationFormProps> = ({
	sitekey,
	onSuccess,
}) => <AccountsOverviewContainer sitekey={sitekey} onSuccess={onSuccess} />;

export default AccountsOverview;
